// Haptic feedback utility using web-haptics
// Provides vibration feedback on supported mobile devices

import { WebHaptics } from 'web-haptics';

let haptics: WebHaptics | null = null;

function getHaptics(): WebHaptics | null {
  if (typeof window === 'undefined') return null;
  if (!haptics) {
    haptics = new WebHaptics();
  }
  return haptics;
}

function isEnabled(): boolean {
  if (typeof window === 'undefined') return true;
  const stored = localStorage.getItem('haptics-enabled');
  return stored !== 'false';
}

export function triggerHaptic(preset: 'success' | 'warning' | 'error' | 'light' | 'medium' | 'heavy' | 'selection' | 'nudge' | 'soft' | 'rigid'): void {
  if (!isEnabled()) return;
  const h = getHaptics();
  if (!h) return;
  h.trigger(preset).catch(() => {});
}

export function setHapticsEnabled(enabled: boolean): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem('haptics-enabled', String(enabled));
}

export function getHapticsEnabled(): boolean {
  return isEnabled();
}
